export default {
  slug: "resharper-cpp",
  code: "RScpp",
  label: "ReSharper C++",
  isIDE: true,
  krakenDir: "ReSharperCpp",
  logoFamily: "ide",
};
